import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker/public_api';
import { ToastrService, ToastrModule } from 'ngx-toastr';
import { LegacyBookInitService } from '../../../shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { RGuestMessages } from 'app/model/shared/backend-api-response/rguest-messages';
export interface DialogData {
  OfferCode: string;
  ArrDepDate: any;
  minDate: any;
  maxNightsAllowed: any;
  clear: boolean;
  ArrDate: string;
  DepDate: string;
  errorMsg: string;
  pageFromRoom: boolean;
  onShowPicker: (event: Event) => void;
}

@Component({
  selector: 'offer-dialog',
  templateUrl: 'offerDialog.component.html',
  styles: [``],
})
export class offerDialogComponent {
  bsConfig: Partial<BsDatepickerConfig>;
  colorTheme = 'theme-dark-blue ';
  ArrDepDate: Array<any> = [];
  OfferCode: string;
  ArrDate: string;
  DepDate: string;
  rGuestBookMessages: RGuestMessages;
  maxNightsAllowed: any;

  constructor(
    public dialogRef: MatDialogRef<offerDialogComponent>,
    public toastr: ToastrService,
    public appInit: LegacyBookInitService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.rGuestBookMessages = this.appInit?.PropertyData?.rGuestMessages;
  }

  ngOnInit() {
    this.bsConfig = Object.assign({}, { containerClass: this.colorTheme, displayMonths: 1, showWeekNumbers: false });
    this.data.clear = false;
    this.maxNightsAllowed = this.data.maxNightsAllowed;
    $('mat-dialog-container').css('overflow', 'hidden');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  clearFilter() {
    this.data.ArrDepDate = [];
    this.data.OfferCode = '';
  }

  validatedates(selectedDate: any) {
    if (Array.isArray(selectedDate)) {
      if (selectedDate.length > 0) {
        let ArrivalDate: Date = selectedDate[0];
        let DepartureDate: Date = selectedDate[1];
        ArrivalDate = new Date(ArrivalDate);
        let ArrDate = this.getDate(ArrivalDate);
        DepartureDate = new Date(DepartureDate);
        let DepDate = this.getDate(DepartureDate);
        let outArrivalDate = ArrDate;
        let outDepartureDate = ArrDate;
        var timeDiff = Math.abs(ArrivalDate.getTime() - DepartureDate.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        this.data.ArrDate = ArrDate;
        this.data.DepDate = DepDate;

        if (this.maxNightsAllowed != 0 && diffDays > this.maxNightsAllowed) {
          this.data.ArrDepDate = [];
          this.data.ArrDate = '';
          this.data.DepDate = '';
          let errordate = this.data.errorMsg + this.maxNightsAllowed + ' day(s)';
          // if ($("#toast-container").html() == undefined) {
          //   this.toastr.error(errordate);
          // }

          this.toastr.error(errordate);
        }
      }
    }
  }

  onShowPicker(event) {
    this.data.onShowPicker(event);
  }

  getDate(UnformattedDate: Date) {
    let mm, dd, yyyy;
    mm = UnformattedDate.getMonth() + 1;
    mm = this.checkFormat(mm);
    dd = UnformattedDate.getDate();
    dd = this.checkFormat(dd);
    yyyy = UnformattedDate.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
  }

  checkFormat(i) {
    if (i < 10) {
      i = '0' + i;
    }
    return i;
  }
}
